import React from 'react';

export default function Logo() {
    return (
        <img className="logo" src="img/freehomeappraisal-logo-client.png" alt="FreeHomeAppraisal.com Logo" />
    )
}
